module.exports = __webpack_public_path__ + "img/bg_avatar_female_48.a20c75f2.png";